<ng-container>
    <div class="container-fluid">
        <fieldset class="border rounded-3 p-1">
            <legend class="float-none w-auto px-1 ml-1 font-size-13">{{'REVIEW_SOL_SUMMARY_TAB.TITLE' | translate}}
            </legend>
            <div class="row" [formGroup]="costReviewSOLSummaryFormGroup" trackChanges>
                <div class="col-sm-6">
                    <div class="row bottomPadding  row-height-plain-text">
                        <div class="col-sm-4">
                            <label>{{'REVIEW_SOL_SUMMARY_TAB.PROJECT_NAME' | translate}}</label>
                        </div>
                        <div class="col-sm-8">
                            <span class="addPadding">{{costReviewSummary?.projectName}}</span>
                        </div>
                    </div>
                    <div class="row bottomPadding row-height-plain-text">
                        <div class="col-sm-4">
                            <label>{{'COMMON_LABELS.ACCOUNT_NAME' | translate}}</label>
                        </div>
                        <div class="col-sm-8">
                            <span class="addPadding">{{costReviewSummary?.customerName}}</span>
                        </div>
                    </div>
                    <div class="row bottomPadding row-height-plain-text">
                        <div class="col-sm-4">
                            <label>{{'REVIEW_SOL_SUMMARY_TAB.SHIP_TO_ADDRESS' | translate}}</label>
                        </div>
                        <div class="col-sm-8">
                            <span class="addPadding">{{costReviewSummary?.shipToLocation}}</span>
                        </div>
                    </div>
                    <div class="row bottomPadding row-height-plain-text">
                        <div class="col-sm-4">
                            <label>{{'REVIEW_SOL_SUMMARY_TAB.PROJECT_CATEGORY_VERIFICATION' |
                                translate}}</label>
                        </div>
                        <div class="col-sm-8 d-flex align-items-center">                            
                            <si-drop-down formControlName="projectCategoryVerification"
                            [dropDownList]="projectCategoryVerificationList" [isReadMode]="isReadOnlyMode"
                                [isDisabled]="isDisabled">
                            </si-drop-down>
                        </div>
                    </div>
                    <div class="row bottomPadding row-height-plain-text" *ngIf="business === constants.BUSINESS_FIRE">
                        <div class="col-sm-4">
                            <label>{{'REVIEW_SOL_SUMMARY_TAB.AUTHORITY_HAVING_JURISDICTION' |
                                translate}}</label>
                        </div>
                        <div class="col-sm-8">
                            <app-si-form-field [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [maxlength]="40"
                             formControlName="authorityHavingJurisdiction"></app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding row-height-plain-text" *ngIf="business === constants.BUSINESS_FIRE">
                        <div class="col-sm-4">
                            <label>{{'REVIEW_SOL_SUMMARY_TAB.NATIONAL_OR_ENTERPRISE_ACCOUNT' |
                                translate}}</label>
                        </div>
                        <div class="col-sm-8">
                            <mat-radio-group class="d-flex align-items-center" formControlName="nationalOrEnterpriseAccount">
                                <si-radio-button class="col-sm-4" [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode"
                                    [isDisabled]="isDisabled"></si-radio-button>
                                <si-radio-button class="col-sm-4" [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode"
                                    [isDisabled]="isDisabled"></si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding row-height-plain-text"
                        *ngIf="(business === constants.BUSINESS_AUTOMATION || business === constants.BUSINESS_MECHANICAL || business === constants.BUSINESS_ELECTRICAL) ||(business === constants.BUSINESS_FIRE)">
                        <div class="col-sm-4">
                            <label>{{'REVIEW_SOL_SUMMARY_TAB.CONSULTING_ENGINEER' | translate}}</label>
                        </div>
                        <div class="col-sm-8 d-flex align-items-center">
                            <app-si-form-field class="col-sm-12" [maxlength]="40" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" formControlName="consultingEngineer"></app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding row-height-plain-text"
                        *ngIf="(business === constants.BUSINESS_SECURITY) || 
                        ((business === constants.BUSINESS_FIRE || business === constants.BUSINESS_AUTOMATION || business === constants.BUSINESS_MECHANICAL || business === constants.BUSINESS_ELECTRICAL) && isSalePriceGreaterThan150)">
                        <div class="col-sm-4">
                            <label>{{'REVIEW_SOL_SUMMARY_TAB.ARCHITECTURE_ENGINEERING_FIRM' |
                                translate}}</label>
                        </div>
                        <div class="col-sm-8 d-flex align-items-center">
                            <app-si-form-field class="col-sm-12" [maxlength]="40"
                            [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" formControlName="architectureFirm"></app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding row-height-plain-text" *ngIf="isAutomationFireSecurity">
                        <div class="col-sm-4">
                            <label>{{'REVIEW_SOL_SUMMARY_TAB.CONSTRUCTION_MANAGER' | translate}}</label>
                        </div>
                        <div class="col-sm-8 d-flex align-items-center">
                            <app-si-form-field class="col-sm-12" [maxlength]="40"
                            [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" formControlName="constructionManager"></app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding  row-height-plain-text"
                        *ngIf="isAutomationFireSecurity">
                        <div class="col-sm-4">
                            <label>{{'REVIEW_SOL_SUMMARY_TAB.JOBSITE_RT_MILEAGE' | translate}}</label>
                        </div>
                        <div class="col-sm-8 d-flex align-items-center">
                            <app-si-form-field class="col-sm-12" [type]="'number'" [maxlength]="4" [max]="9999"
                            [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" formControlName="jobsiteRtMileage"></app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding row-height-plain-text">
                        <div class="col-sm-4">
                            <label>{{'REVIEW_SOL_SUMMARY_TAB.PROJECT_START_DATE' | translate}}</label>
                        </div>
                        <div class="col-sm-4 d-flex align-items-center">
                            <app-si-date-picker [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" formControlName="projectStartDate"></app-si-date-picker>
                        </div>
                        <div class="col-sm-4 d-flex align-items-center duration-container">
                            <span class="col-sm-6">
                                {{'REVIEW_SOL_SUMMARY_TAB.DURATION_DAYS' | translate}}
                            </span>
                            <app-si-form-field class="col-sm-6 ps-0" formControlClass="col-sm-12" [type]="'number'" [maxlength]="4" [max]="9999"
                                [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" formControlName="projectDuration" ngDefaultControl></app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding row-height-plain-text">
                        <div class="col-sm-4">
                            <label>{{'REVIEW_SOL_SUMMARY_TAB.PROJECT_END_DATE' | translate}}</label>
                        </div>
                        <div class="col-sm-4 d-flex align-items-center">
                            <app-si-date-picker formControlName="projectEndDate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></app-si-date-picker>
                        </div>
                    </div>
                    <div class="row bottomPadding"  *ngIf="business !== constants.BUSINESS_SECURITY">
                        <div class="col-sm-4">
                            <label>{{'REVIEW_SOL_SUMMARY_TAB.ESTIMATE_DEPTH' | translate}}</label>
                        </div>
                        <div class="col-sm-8">
                            <mat-radio-group class=" d-flex align-items-center" formControlName="estimateDepth">
                                <si-radio-button  [displayText]="'COST_REVIEW_SUMMARY_TAB_DETAILED' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                                <si-radio-button  [displayText]="'COST_REVIEW_SUMMARY_TAB_SUMMARY' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding row-height-plain-text">
                        <div class="col-sm-4">
                            <label>{{'REVIEW_SOL_SUMMARY_TAB.COLLABORATIVE' | translate}}</label>
                        </div>
                        <div class="col-sm-8">
                            <span class="addPadding">{{costReviewSummary?.isCollaborative}}</span>
                        </div>
                    </div>
                    <div class="row bottomPadding row-height-plain-text"
                        *ngIf="costReviewSummary?.isFireTBEVisibility && costReviewSummary?.fireTaskBasedEstimating">
                        <div class="col-sm-4">
                            <label>{{'REVIEW_SOL_SUMMARY_TAB.TASK_BASED_ESTIMATING_USED' | translate}}</label>
                        </div>
                        <div class="col-sm-8">
                            <span class="addPadding">{{costReviewSummary?.fireTaskBasedEstimating}}</span>
                        </div>
                    </div>
                    <div class="row bottomPadding row-height-plain-text"
                        *ngIf="costReviewSummary?.isFireTBEVisibility && costReviewSummary?.fireTaskBasedEstimating && !isFireTaskBasedEstimatingYes">
                        <div class="col-sm-4">
                            <label class="margin-left-10">{{'REVIEW_SOL_SUMMARY_TAB.SM_APPROVAL_RECEIVED' |
                                translate}}</label>
                        </div>
                        <div class="col-sm-8">
                            <mat-radio-group class=" d-flex align-items-center" formControlName="smApprovalRecieved" (change)="onSmApprovalChange()">
                                <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                                <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding"
                        *ngIf="business !== constants.BUSINESS_SECURITY">
                        <div class="col-sm-4">
                            <label>{{'REVIEW_SOL_SUMMARY_TAB.ALTERNATIVES_INCLUDED' | translate}}</label>
                        </div>
                        <div class="col-sm-8">
                            <mat-radio-group class=" d-flex align-items-center" formControlName="alternatesIncluded">
                                <si-radio-button  [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                                <si-radio-button  [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding  row-height-plain-text" *ngIf="business !== constants.BUSINESS_SECURITY">
                        <div class="col-sm-4">
                            <label>{{'REVIEW_SOL_SUMMARY_TAB.OPPORTUNITY_LINKED' | translate}}</label>
                        </div>
                        <div class="col-sm-8">
                            <span class="addPadding">{{costReviewSummary?.opportunityLinked}}</span>
                        </div>
                    </div>
                    <div class="row bottomPadding"
                        *ngIf="business !== constants.BUSINESS_SECURITY">
                        <div class="col-sm-4">
                            <label>{{'REVIEW_SOL_SUMMARY_TAB.CONSTRUCTION' | translate}}</label>
                        </div>
                        <div class="col-sm-8">
                            <mat-radio-group class=" d-flex align-items-center" formControlName="construction">
                                <si-radio-button  [displayText]="'COST_REVIEW_SUMMARY_TAB_NEW' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                                <si-radio-button  [displayText]="'COST_REVIEW_SUMMARY_TAB_REHAB' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                            </mat-radio-group>
                            </div>
                    </div>
                    @if(business !== constants.BUSINESS_SECURITY) {
                    <div class="row bottomPadding">
                        <div class="col-sm-4  ps-5">
                            <label class="margin-left-10">{{'REVIEW_SOL_SUMMARY_TAB.IF_NEW_SUFFICIENT_SPACE' |
                                translate}}</label>
                        </div>
                        <div class="col-sm-8 ">
                            <mat-radio-group class="d-flex align-items-center" formControlName="sufficientSpace">
                                <si-radio-button  [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled || isSufficientSpaceDisabled"></si-radio-button>
                                <si-radio-button  [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled || isSufficientSpaceDisabled"></si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    }
                    <div class="row bottomPadding  row-height-plain-text"
                        *ngIf="costReviewSummary?.isGraphicsStandardVerifiedWithGISVisible && business !== constants.BUSINESS_SECURITY">
                        <div class="col-sm-4">
                            <label>{{'REVIEW_SOL_SUMMARY_TAB.GRAPHICS_STANDARD_VERIFIED' | translate}}</label>
                        </div>
                        <div class="col-sm-8">
                            <span class="addPadding">{{getParameterValues(constants.YES_NO,costReviewSummary?.graphicsStandardVerifiedWithGIS)}}</span>
                        </div>
                    </div>
                    <div class="row bottomPadding  row-height-plain-text" *ngIf="costReviewSummary?.verticalMarket">
                        <div class="col-sm-4">
                            <label>{{'REVIEW_SOL_SUMMARY_TAB.VERTICAL_MARKET' | translate}}</label>
                        </div>
                        <div class="col-sm-8">
                            <span class="addPadding">{{costReviewSummary?.verticalMarket}}</span>
                        </div>
                    </div>
                    <!-- Implementation of Job Details in Fire Solutions -->
                    @if (business === constants.BUSINESS_FIRE) {                    
                    <div class="row bottomPadding">
                        <fieldset class="border rounded-3 p-1">
                            <legend>{{'JOB_DETAILS' | translate}}</legend>
                        <div class="row">
                            <div class="col-sm-8">
                                <div class="row align-items-center">
                                    <label class="col-sm-5 addPadding">{{'PRODUCT_OFFERING' | translate}}</label>
                                    <span class="col-sm-7 addPadding">{{productOfferingsDisplay}}</span>
                                </div>                            
                                <div class="row align-items-center">
                                    <label class="col-sm-5 addPadding">{{'INSTALLATION_TYPE' | translate}}</label>
                                    <span class="col-sm-7 addPadding">{{jobDetailsInstallationType}}</span>
                                </div>
                                @if (jobDetails.isSiteSizeEnabled) {
                                <div class="row align-items-center">
                                    <label class="col-sm-5 addPadding">{{'SITE_SIZE_SQUARE_FOOTAGE' | translate}}</label>
                                    <span class="col-sm-7 addPadding">{{jobDetails.siteSize}}</span>
                                </div>
                                }
                                @if (jobDetails.isAntennaQtyEnabled) {
                                <div class="row align-items-center">
                                    <label class="col-sm-5 addPadding">{{'ANTENNA_QTY' | translate}}</label>
                                    <span class="col-sm-7 addPadding">{{jobDetails.antennaQty}}</span>
                                </div>
                                }
                                @if (jobDetails.isAgentWeightEnabled){
                                <div class="row align-items-center">
                                    <label class="col-sm-5 addPadding">{{'AGENT_WEIGHT' | translate}}</label>
                                    <span class="col-sm-7 addPadding">{{jobDetails.agentWeight}} {{'LBS.' | translate}}</span>
                                </div>
                                }
                                @if (jobDetails.isCleanAgentNetVolSpaceEnabled){
                                <div class="row align-items-center">
                                    <label class="col-sm-5 addPadding">{{'CLEAN_AGENT_NET_VOL_SPACE' | translate}}</label>
                                    <span class="col-sm-7 addPadding">{{jobDetails.cleanAgentNetVolSpace}} {{'CUBIC_FEET' | translate}}</span>
                                </div>
                                }
                            </div>
                            <div class="col-sm-4">
                                <span class="d-flex flex-column align-items-start gap-2 justify-content-center h-100">
                                    @if(costReviewSummary?.hasJobDetailsValidationError) {
                                        <label>{{'REQUIRED_CLICK_HERE_TO_POPULATE' | translate}}</label>
                                        <span class="d-flex gap-2">
                                            <mat-icon class="warning-icon">warning icon</mat-icon>
                                            <button mat-raised-button color="primary" (click)="openJobDetailsDialog()" [disabled]="isJobDetailsButtonDisabled || isDisabled || isReadOnlyMode">{{'JOB_DETAILS' | translate}}</button>
                                        </span>
                                    }
                                </span>
                            </div>
                        </div>
                        </fieldset>
                    </div>
                    }
                    <div class="row bottomPadding  row-height-plain-text" *ngIf="isLaborEfficiencyVisible">
                        <div class="col-sm-4">
                            <label>{{'REVIEW_SOL_SUMMARY_TAB.LABOR_EFFICIENCY' | translate}}</label>
                        </div>
                        <div class="col-sm-8">
                            <span class="addPadding">{{costReviewSummary?.laborEfficiency}}</span>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="row bottomPadding align-items-start"
                        *ngIf="business !== constants.BUSINESS_SECURITY">
                        <div class="col-sm-4">
                            <label class="top-label">{{'REVIEW_SOL_SUMMARY_TAB.PROJECT_SCOPE' | translate}}</label>
                        </div>
                        <div class="col-sm-8">

                            <mat-radio-group formControlName="projectScope">
                                <si-radio-button  [displayText]="'COST_REVIEW_SUMMARY_TAB_PROVEN_TECHNOLOGY' | translate" [isReadMode]="isReadOnlyMode"
                                    [isDisabled]="isDisabled"></si-radio-button>
                                <si-radio-button  [displayText]="'COST_REVIEW_SUMMARY_TAB_NEW_RELEASE' | translate" [isReadMode]="isReadOnlyMode"
                                    [isDisabled]="isDisabled"></si-radio-button>
                                <si-radio-button  [displayText]="'COST_REVIEW_SUMMARY_TAB_PROVEN_TECHNOLOGY_NEW_ENVIRONMENT' | translate"
                                    [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                                <si-radio-button  [displayText]="'COST_REVIEW_SUMMARY_TAB_DEVELOPED_FINALIZED_FIRST_TIME' | translate"
                                    [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                                <si-radio-button  [displayText]="'COST_REVIEW_SUMMARY_TAB_TECHNOLOGY_IN_DEVELOPMENT' | translate" [isReadMode]="isReadOnlyMode"
                                    [isDisabled]="isDisabled"></si-radio-button>
                            </mat-radio-group> 
                            <app-si-form-field [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled || isProjectScopeDescDisabled" formControlName="projectScopeDescription"></app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding align-items-start" [formGroup]="costReviewSOLSummaryFormGroup"
                        *ngIf="business !== constants.BUSINESS_SECURITY">
                        <div class="col-sm-4">
                            <label class="top-label">{{'REVIEW_SOL_SUMMARY_TAB.CLARITY_OF_SCOPE' | translate}}</label>
                        </div>
                        <div class="col-sm-8">

                            <mat-radio-group formControlName="clarityOfScope">
                                <si-radio-button  [displayText]="'COST_REVIEW_SUMMARY_TAB_PROVEN_TECHNOLOGY_NEW_ENVIRONMENT' | translate"
                                    [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                                </si-radio-button>
                                <si-radio-button  [displayText]="'COST_REVIEW_SUMMARY_TAB_DEVELOPED_FINALIZED_FIRST_TIME' | translate"
                                    [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                                </si-radio-button>
                                <si-radio-button  [displayText]="'COST_REVIEW_SUMMARY_TAB_TECHNOLOGY_IN_DEVELOPMENT' | translate" [isReadMode]="isReadOnlyMode"
                                    [isDisabled]="isDisabled">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>                                      
                    <div class="row bottomPadding" 
                        *ngIf="business !== constants.BUSINESS_SECURITY">
                        <div class="col-sm-4">
                            <label>{{'REVIEW_SOL_SUMMARY_TAB.COMMISSIONING_REQUIREMENTS' | translate}}</label>
                        </div>

                        <div class="col-sm-8 d-flex">
                            <mat-radio-group class="radio-group d-flex align-items-center"
                                formControlName="commissioningRequirements">
                                <si-radio-button class="col-sm-4 " [displayText]="'COST_REVIEW_SUMMARY_TAB_OWN_RSS' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                                </si-radio-button>
                                <si-radio-button class="col-sm-4 " [displayText]="'COST_REVIEW_SUMMARY_TAB_3RD_PARTY' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                                </si-radio-button>
                                <si-radio-button class="col-sm-4 " [displayText]="'N_A' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"
                                                 *ngIf="business === constants.BUSINESS_FIRE">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding"
                        *ngIf="business !== constants.BUSINESS_SECURITY && business !== constants.BUSINESS_FIRE">
                        <div class="col-sm-4">
                            <label>{{'REVIEW_SOL_SUMMARY_TAB.M_AND_V_REPORTING_REQUIRED' | translate}}</label>
                        </div>
                        <div class="col-sm-8">
                            <mat-radio-group class="radio-group d-flex align-items-center"
                                formControlName="mvReporting">
                                <si-radio-button class="col-sm-4 " [displayText]="'YES'| translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                                </si-radio-button>
                                <si-radio-button class="col-sm-4 " [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding"
                        *ngIf="business !== constants.BUSINESS_SECURITY">
                        <div class="col-sm-4">
                            <label>{{'REVIEW_SOL_SUMMARY_TAB.RESOURCE_REQUIREMENTS' | translate}}</label>
                        </div>
                        <div class="col-sm-8 d-flex align-items-center">
                            <mat-radio-group class="radio-group align-items-center"
                                formControlName="resourceRequirements">
                                <span class="d-flex">
                                    <si-radio-button class="col-sm-4 " [displayText]="'COST_REVIEW_SUMMARY_TAB_GOOD_OR_NEUTRAL_EXPERIENCE' | translate" [isReadMode]="isReadOnlyMode"
                                        [isDisabled]="isDisabled"></si-radio-button>
                                    <si-radio-button class="col-sm-4 " [displayText]="'COST_REVIEW_SUMMARY_TAB_NEGATIVE_EXPERIENCE' | translate" [isReadMode]="isReadOnlyMode"
                                        [isDisabled]="isDisabled"></si-radio-button>
                                    <si-radio-button class="col-sm-4 " [displayText]="'COST_REVIEW_SUMMARY_TAB_NO_EXPERIENCE' | translate" [isReadMode]="isReadOnlyMode"
                                        [isDisabled]="isDisabled"></si-radio-button>
                                    </span>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding"
                        *ngIf="business !== constants.BUSINESS_SECURITY">
                        <div class="col-sm-4 d-flex">
                            <label
                                >{{'REVIEW_SOL_SUMMARY_TAB.THIRD_PARTY_RESOURCES_REQUIRED' |
                                translate}}</label>
                                @if(isAutomationOrElectrical){
                                <mat-icon class="info-icon" [matTooltipDisabled]="isDisabled" [matTooltip]="'MATERIAL_LABOR_REQUIRED_BY_OTHERS' | translate">info</mat-icon>
                                }
                        </div>
                        <div class="col-sm-8 align-items-center">
                            <mat-radio-group class="radio-group align-items-center"
                                formControlName="thirdPartyResources">
                                <span class="d-flex">
                                    <si-radio-button class="col-sm-4 " [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                                    <si-radio-button class="col-sm-4 " [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                                    <si-radio-button class="col-sm-4 " [displayText]="'COST_REVIEW_SUMMARY_TAB_UNKNOWN' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                                </span>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding" *ngIf="business !== constants.BUSINESS_SECURITY">
                        <div class="col-sm-4"></div>
                        <div class="col-sm-8">
                            <app-si-form-field [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled || isThirdPartyResourceDescDisabled" formControlName="thirdPartyResourceRequiredDescription"></app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding"
                        *ngIf="business !== constants.BUSINESS_SECURITY">
                        <div class="col-sm-4 d-flex">
                            <label
                                >{{'REVIEW_SOL_SUMMARY_TAB.SITE_ACCESS' | translate}}</label>
                                @if(isAutomationOrElectrical){
                                <mat-icon class="info-icon"
                                    [matTooltipDisabled]="isDisabled" [matTooltip]="'ARE_THERE_REQUIREMENTS_TO_ACCESS_SITE' | translate">info</mat-icon>
                                }
                        </div>
                        <div class="col-sm-8 d-flex align-items-center">
                            <mat-radio-group class="radio-group align-items-center" formControlName="siteAccess">
                                <span class="d-flex">
                                    <si-radio-button class="col-sm-4 " [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                                    <si-radio-button class="col-sm-4 " [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                                    <si-radio-button class="col-sm-4 " [displayText]="'COST_REVIEW_SUMMARY_TAB_UNKNOWN' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                                </span>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding"
                        *ngIf="business !== constants.BUSINESS_SECURITY">
                        <div class="col-sm-4">
                            <label>{{'REVIEW_SOL_SUMMARY_TAB.HIGH_WORK_AREA' | translate}}</label>
                        </div>
                        <div class="col-sm-8  d-flex align-items-center">
                            <mat-radio-group class="radio-group d-flex align-items-center"
                                formControlName="highWorkArea">
                                <si-radio-button class="col-sm-4 " [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                                <si-radio-button class="col-sm-4 " [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding" *ngIf="business === constants.BUSINESS_FIRE">
                        <div class="col-sm-4">
                            <label>{{'REVIEW_SOL_SUMMARY_TAB.ZTE_APPROVAL_RECEIVED' | translate}}</label>
                            <mat-icon class="info-icon" [matTooltipDisabled]="isDisabled"
                                    [matTooltip]="'ZTE_APPROVAL_REQUIRED' | translate">info</mat-icon>
                        </div>
                        <div class="col-sm-8">
                            <mat-radio-group class="col-sm-8  d-flex align-items-center" formControlName="zteApprovalReceived">
                            <si-radio-button class="col-sm-4 " [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode"
                                [isDisabled]="isDisabled"></si-radio-button>
                            <si-radio-button class="col-sm-4 " [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode"
                                [isDisabled]="isDisabled"></si-radio-button>
                            </mat-radio-group> 
                        </div>
                    </div>
                    <div class="row bottomPadding" *ngIf="business === constants.BUSINESS_SECURITY">
                        <div class="col-sm-4">
                            <label>{{'REVIEW_SOL_SUMMARY_TAB.ESTIMATE_DEPTH' | translate}}</label>
                        </div>
                        <div class="col-sm-8" >
                            <mat-radio-group class="col-sm-8  d-flex align-items-center" formControlName="estimateDepth">
                            <si-radio-button class="col-sm-4 " [displayText]="'COST_REVIEW_SUMMARY_TAB_DETAILED' | translate" [isReadMode]="isReadOnlyMode"
                                [isDisabled]="isDisabled"></si-radio-button>
                            <si-radio-button class="col-sm-4 " [displayText]="'COST_REVIEW_SUMMARY_TAB_SUMMARY' | translate" [isReadMode]="isReadOnlyMode"
                                [isDisabled]="isDisabled"></si-radio-button>
                            </mat-radio-group> 
                        </div>
                    </div>
                    <div class="row bottomPadding" *ngIf="business === constants.BUSINESS_SECURITY">
                        <div class="col-sm-4">
                            <label>{{'REVIEW_SOL_SUMMARY_TAB.OPPORTUNITY_LINKED' | translate}}</label>
                        </div>
                        <div class="col-sm-8">
                            <span class="addPadding">{{costReviewSummary?.opportunityLinked}}</span>
                        </div>
                    </div>
                    <div class="row bottomPadding" *ngIf="business === constants.BUSINESS_SECURITY">
                        <div class="col-sm-4">
                            <label>{{'REVIEW_SOL_SUMMARY_TAB.PROPOSAL_LINKED' | translate}}</label>
                        </div>
                        <div class="col-sm-8">
                            <span class="addPadding">{{costReviewSummary?.proposalLinked}}</span>
                        </div>
                    </div>
                    <div class="row bottomPadding" *ngIf="business === constants.BUSINESS_SECURITY">
                        <div class="col-sm-4">
                            <label>{{'REVIEW_SOL_SUMMARY_TAB.ALTERNATES_INCLUDED' | translate}}</label>
                        </div>
                       <div class="col-sm-8">
                            <mat-radio-group class=" d-flex align-items-center" formControlName="alternatesIncluded">
                                <si-radio-button class="col-sm-4 " [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                                <si-radio-button class="col-sm-4 " [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>



                    <div class="row bottomPadding" *ngIf="business === constants.BUSINESS_SECURITY">
                        <div class="col-sm-4">
                            <label>{{'REVIEW_SOL_SUMMARY_TAB.CONTINGENCY_INCLUDED' | translate}}</label>
                        </div>
                        <div class="col-sm-3">
                            
                            <app-si-form-field [type]="'percent'" formControlName="contigencyIncluded"
                                [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding" *ngIf="business === constants.BUSINESS_SECURITY">
                        <div class="col-sm-4">
                            <label>{{'REVIEW_SOL_SUMMARY_TAB.SIEMENS_A_PRIME_BIDDER' | translate}}</label>
                        </div>
                        <div class="col-sm-8">
                            <mat-radio-group class=" d-flex align-items-center" formControlName="siemensPrimeBidder">
                                <si-radio-button class="col-sm-4 " [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                                <si-radio-button class="col-sm-4 " [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></si-radio-button>
                            </mat-radio-group>

                        </div>
                    </div>

                    <div class="row bottomPadding"
                        *ngIf="(business !== constants.BUSINESS_AUTOMATION &&  business !== constants.BUSINESS_MECHANICAL) && costReviewSummary?.isPriceRecommenderUsed">
                        <div class="col-sm-4">
                            <label>{{'REVIEW_SOL_SUMMARY_TAB.MARGIN_RECOMMENDER_USED' | translate}}</label>
                        </div>
                        <div class="col-sm-8">
                            <span class="addPadding">{{costReviewSummary?.isPriceRecommenderUsed}}</span>
                        </div>
                    </div>
                    <div class="row bottomPadding" *ngIf="costReviewSummary?.isCDP">
                        <div class="col-sm-4">
                            <label>{{'REVIEW_SOL_SUMMARY_TAB.CONNECTED_DIGITAL_PACKAGE' | translate}}</label>
                        </div>
                        <div class="col-sm-8">
                            <span class="addPadding">{{costReviewSummary?.isCDP}}</span>
                        </div>
                    </div>
                    <div class="row bottomPadding" *ngIf="costReviewSummary?.isEnergyOMReviewRequired && isServiceProjectSubsegment()">
                        <div class="col-sm-4">
                            <label>{{'REVIEW_SOL_SUMMARY_TAB.ENERGY_OM_COST_REVIEW_REQUIRED' |
                                translate}}</label>
                        </div>
                        <div class="col-sm-8">
                            <span class="addPadding">{{costReviewSummary?.isEnergyOMReviewRequired}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </fieldset>
    </div>
</ng-container>


